import Typography from "@mui/material/Typography";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
// const getStatusBadge = (status) => {
//   const inferedStatus = status || "Awaiting Delivery";
//   const text = inferedStatus.replace(/ /g, "%20");
//   switch (inferedStatus) {
//     case "Awaiting Delivery":
//       return `<img src="https://img.shields.io/badge/Awaiting%20Delivery-FF6600" />`;
//     case "Delivered":
//       return `<img src="https://img.shields.io/badge/Delivered-4379F2" />`;
//     case "Checked":
//       return `<img src="https://img.shields.io/badge/Checked-117554" />`;
//     default:
//       return `<img src="https://img.shields.io/badge/${text}-FF6600" />`;
//   }
// };
const FabricsTable = ({ projectData }) => {
  const fabrics = projectData.fabrics || [];
  // room, window,product,fabric,status
  const columns = [
    { field: "brand", headerName: "Brand", width: 100 },
    { field: "design", headerName: "Design", width: 150 },
    { field: "colour", headerName: "Colour", width: 120 },
    { field: "width", headerName: "Width", width: 75 },
    { field: "eta", headerName: "ETA", width: 100 },
    { field: "notes", headerName: "Notes", width: 250 },
    { field: "status", headerName: "Status", width: 150 },
    {
      field: "replacement_required",
      headerName: "Replacement Required",
      width: 200,
    },
  ];

  const rows = fabrics.map((fabric, index) => ({
    id: index,
    brand: fabric.brand,
    design: fabric.design,
    colour: fabric.colour,
    width: fabric.width,
    eta: fabric.eta,
    notes: fabric?.notes,
    status: fabric.status || "Awaiting Delivery", //getStatusBadge(fabric.status),
    replacement_required: fabric?.replacement_required,
  }));

  return (
    <div style={{ width: "100%", margin: "2rem" }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Fabrics
      </Typography>
      <DataGrid rows={rows} columns={columns} hideFooter />
    </div>
  );
};

export default FabricsTable;
